// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2485":"7f2b661f","5996":"121d6436","8449":"22f75f4f"}[chunkId] || chunkId) + "." + {"639":"3c68f8198ef8495b","2485":"c0a5fff3681209f8","5996":"2271243cca5f5e2c","6260":"b6b753e1c9117854","7570":"0cddd8a940debb7a","8449":"e3e957103650c614"}[chunkId] + ".js";
};